import React from "react";

const Article = () => {
  return (
    <div>
      <div className="mb-20">
        <br></br>
        <h2 id="Intro-EC20"> pGLO </h2>
        <br></br>
        <table>
          <tbody>
            <tr>
              <td>Plasmid</td>
              <td>pGLO</td>
            </tr>
            <tr>
              <td>Resistance</td>
              <td>Ampicillin</td>
            </tr>
            <tr>
              <td>Tag</td>
              <td>None</td>
            </tr>
            <tr>
              <td>Expression system</td>
              <td>Facultative (inducibly) expressed</td>
            </tr>
          </tbody>
        </table>
        <br></br>
        <h2 id="Transformation-EC20">
          {" "}
          Transformation of pGLO plasmid into DH5α{" "}
        </h2>
        <div className="date">12/09/2023</div>
        <p>
          <u>Aim:</u> We received our lyophilized plasmid into a quantity of 20
          ug (diluted 100 ng/ul). As we forecasted that we would need a lot of
          plasmid for the different time/concentration to get Uplasmid, we
          decided to harvest more pGLO. We performed a transformation on DH5a
          which is well-known for this purpose.
        </p>
        <u>Protocol:</u> Bacterial Transformation
        <p>
          <u>Results:</u> We made 4 plates, 2/2 with slighlty different
          protocols. The colonies in the 4 plates grew well.
        </p>
        <br></br>
        <br></br>
        <h2 id="PrimaryCulture-pGLO">
          Primary Culture of transformed DH5α bacteria with pGLO plasmid
        </h2>
        <div className="date">13/09/2023</div>
        <p>
          <u>Aim:</u> Growing of the DH5α transformed bacteria
        </p>
        <u>Protocol:</u> Primary culture
        <p>
          <u>Results:</u>
        </p>
        <br></br>
        <h2 id="SecondaryCulture-pGLO">
          Secondary Culture of transformed DH5α bacteria with pGLO plasmid
        </h2>
        <div className="date">14/09/2023</div>
        <p>
          <u>Aim:</u> Growing of the DH5α transformed bacteria
        </p>
        <u>Protocol:</u> Secondary culture
        <p>
          <u>Results:</u>
        </p>
        <br></br>
        <h2 id="Mini-prep"> Extract pGLO from DH5α </h2>
        <div className="date">15/09/2023</div>
        <p>
          <u>Aim:</u> Collect new plasmid for further experiments
        </p>
        <u>Protocol:</u> Mini-prep
        <p>
          <u>Results:</u> Two tubes with 30 ul with a concentration of 21 ng/ul
          and 23,8 ng/ul (indicated by Nanodrop).
        </p>
        <br></br>
        <h2 id="Transformation-EC20">
          Transformation of pGLO plasmid into CJ236
        </h2>
        <div className="date">15/09/2023</div>
        <p>
          <u>Aim:</u> We started with the main experiment. Transformed our CJ236
          with pGLO.
        </p>
        <u>Protocol:</u> Bacterial Transformation
        <p>
          <u>Results:</u> Six plates were made and the next day colonies were
          formed in all of them
        </p>
        <br></br>
        <h2 id="PrimaryCulture-pGLO">
          Primary Culture of transformed CJ236 bacteria with pGLO plasmid
        </h2>
        <div className="date">16/09/2023</div>
        <p>
          <u>Aim:</u> Growing of the CJ236 transformed bacteria. 2 Falcon tubes
          made.
        </p>
        <u>Protocol:</u> Primary culture
        <p>
          <u>Results:</u>
        </p>
        <br></br>
        <h2 id="SecondaryCulture-pGLO">
          {" "}
          Secondary Culture of transformed CJ236 bacteria with pGLO plasmid
        </h2>
        <div className="date">17/09/2023</div>
        <p>
          <u>Aim:</u> Growing of the CJ236 transformed bacteria. Made two on one
          day and two others the next day.
        </p>
        <u>Protocol:</u> Secondary culture
        <p>
          <u>Results:</u>
        </p>
        <br></br>
        <h2 id="Speed-up Uracilation 20">
          {" "}
          Speed-up Uracilation (20 min) of CJ236 bacteria with pGLO plasmid
        </h2>
        <div className="date">18/09/2023</div>
        <p>
          <u>Aim:</u> Speeding up the incorporation of Uracil into the pGLO
          plasmid. Using the secondary cultures, made 5 tubes of 3 mL with
          0,1,2,5 and 10 ul dUTP/mL secondary, and incubated at 37 C for 20
          minutes.
        </p>
        <u>Protocol:</u> Speed up Uracilation
        <p>
          <u>Results:</u>
        </p>
        <br></br>
        <h2 id="Mini-prep 20">
          {" "}
          Immediately extract UpGLO (20 min) from CJ236{" "}
        </h2>
        <div className="date">18/09/2023</div>
        <p>
          <u>Aim:</u> Collect Uplasmid for further experiments
        </p>
        <u>Protocol:</u> Mini-prep
        <p>
          <u>Results:</u> Plasmids collected were 7, 16.6, 10.8, 10 and 12.3
          ng/ul for the 0,1,2,5,10 ul dUTP/mL conditions respectively (indicated
          by Nanodrop).
        </p>
        <br></br>
        <h2 id="Speed-up Uracilation">
          Speed-up Uracilation (30 min) of CJ236 bacteria with pGLO plasmid.
        </h2>
        <div className="date">22/09/2023</div>
        <p>
          <u>Aim:</u> Speeding up the incorporation of Uracil into the pGLO
          plasmid. Using the secondary cultures, made 5 tubes of 3 mL with
          0,1,2,5 and 10 ul dUTP/mL secondary, and incubated at 37 C for 30
          minutes.
        </p>
        <u>Protocol:</u> Speed up Uracilation
        <p>
          <u>Results:</u>
        </p>
        <br></br>
        <h2 id="Mini-prep 30">
          {" "}
          Immediately extract UpGLO (30 min) from CJ236{" "}
        </h2>
        <div className="date">22/09/2023</div>
        <p>
          <u>Aim:</u> Collect Uplasmid for further experiments
        </p>
        <u>Protocol:</u> Mini-prep
        <p>
          <u>Results:</u> Plasmids collected were 106.3, 113, 97.2, 74, 105.5
          ng/ul for the 0,1,2,5,10 conditions respectively (indicated by
          Nanodrop).
        </p>
        <br></br>
        <h2 id="Transformation UpGLO">
          Transformation of UpGLO plasmid (20 min) into BL21 and CJ236
        </h2>
        <div className="date">19/09/2023</div>
        <p>
          <u>Aim:</u> Instead of waiting for an eventual HGT, we decided to
          transform the two strains to see if the UpGLO are correctly
          incorporated and the protein expressed.
        </p>
        <u>Protocol:</u> Bacterial Transformation
        <p>
          <u>Results:</u> We made 5+5 plates.
        </p>
        <br></br>
        <h2 id="Transformation UpGLO 30">
          {" "}
          Transformation of UpGLO plasmid (30 min) into BL21, DH5α and CJ236{" "}
        </h2>
        <div className="date">23/09/2023</div>
        <p>
          <u>Aim:</u> Instead of waiting for an eventual HGT, we decided to
          transform the three strains to see if the UpGLO are correctly
          incorporated and the protein expressed.
        </p>
        <u>Protocol:</u> Bacterial Transformation
        <p>
          <u>Results:</u> We made 5+5+5 plates.
        </p>
        <br></br>
        <h2 id="Transformation-EC20DH">
          {" "}
          Transformation of pGLO plasmid into DH5α{" "}
        </h2>
        <div className="date">25/09/2023</div>
        <p>
          <u>Aim:</u> To make a negative control. We want to test that Uplasmid
          cannot be produced with the incorrect strains. Therefore when we will
          repeat the experiments we will collect just simple pGLO and no UpGLO.
          Colonies transformed should be viable.
        </p>
        <u>Protocol:</u> Bacterial Transformation
        <p>
          <u>Results:</u>
        </p>
        <br></br>
        <br></br>
        <h2 id="PrimaryCulture-pGLODH">
          {" "}
          Primary Culture of transformed DH5α bacteria with pGLO plasmid
        </h2>
        <div className="date">26/09/2023</div>
        <p>
          <u>Aim:</u> Growing of the DH5α transformed bacteria
        </p>
        <u>Protocol:</u> Primary culture
        <p>
          <u>Results:</u>
        </p>
        <br></br>
        <h2 id="SecondaryCulture-pGLODH">
          Secondary Culture of transformed DH5α bacteria with pGLO plasmid
        </h2>
        <div className="date">27/09/2023</div>
        <p>
          <u>Aim:</u> Growing of the DH5α transformed bacteria
        </p>
        <u>Protocol:</u> Secondary culture
        <p>
          <u>Results:</u>
        </p>
        <br></br>
        <h2 id="Speed-up Uracilation30.2">
          Speed-up Uracilation (30 min) of DH5α bacteria with pGLO plasmid.
        </h2>
        <div className="date">28/09/2023</div>
        <p>
          <u>Aim:</u> Speeding up the incorporation of Uracil into the pGLO
          plasmid. Using the secondary cultures, made 5 tubes of 3 mL with
          0,1,2,5 and 10 ul dUTP/mL secondary, and incubated at 37 C for 30
          minutes.
        </p>
        <u>Protocol:</u> Speed up Uracilation
        <p>
          <u>Results:</u>
        </p>
        <br></br>
        <h2 id="Mini-prep30.2">
          {" "}
          Immediately extract pGLO (30 min) from DH5α{" "}
        </h2>
        <div className="date">28/09/2023</div>
        <p>
          <u>Aim:</u> Collect Uplasmid for further experiments
        </p>
        <u>Protocol:</u> Mini-prep
        <p>
          <u>Results:</u> Plasmids collected were 48.9, 58.9, 76.7, 68.9 and 64.5
          ng/ul for the 0,1,2,5,10 ul dUTP/mL conditions respectively (indicated
          by Nanodrop).
        </p>
        <br></br>
        
      </div>
    </div>
  );
};

export default Article;
